export type HeroSlide = {
  id: string;
  image: string;
  tag: string;
  title: string;
  slogan: string;
  description: string;
};

export const heroSlides: HeroSlide[] = [
  {
    id: "neighbor-wife",
    image: "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20quiet%20suburban%20apartment%20corridor%20at%20dusk%20with%20warm%20window%20lights%20glowing%20against%20deep%20navy%20blue%20shadow%2C%20atmospheric%20melancholic%20moody%20film%20still%2C%20soft%20light%20rays%2C%20subtle%20film%20grain%2C%20no%20text%2C%20high%20detail%2C%20dramatic%20cinematography&width=1920&height=900&seq=hero-01&orientation=landscape",
    tag: "重点专题",
    title: "邻居的妻子",
    slogan: "对门之隔，藏着多少不曾说出口的心事",
    description: "当日常的礼貌渐渐松动，几个家庭之间脆弱的平衡被一场停电彻底打破。全12集都市情感剧，正在热播。",
  },
  {
    id: "fog-hunter",
    image: "https://readdy.ai/api/search-image?query=cinematic%20wide%20moody%20city%20alley%20shrouded%20in%20dense%20fog%20at%20night%2C%20a%20lone%20detective%20silhouette%20walking%20away%2C%20cold%20deep%20navy%20shadows%20with%20a%20single%20warm%20orange%20streetlamp%2C%20tense%20mysterious%20film%20still%2C%20film%20grain%2C%20no%20text%2C%20high%20detail%2C%20dramatic%20cinematography&width=1920&height=900&seq=hero-02&orientation=landscape",
    tag: "悬疑热播",
    title: "迷雾追凶",
    slogan: "一枚旧车票，牵出从没结案的悬案",
    description: "连续案件现场都留下一枚摩旧的旧车票，退休刑警与年轻法医沿着它追进城市的旧城区。更新至第16集。",
  },
  {
    id: "spring-letter",
    image: "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20blooming%20cherry%20blossom%20branches%20in%20soft%20spring%20sunlight%20with%20an%20old%20wooden%20window%2C%20gentle%20warm%20cream%20and%20pale%20pink%20tones%20against%20a%20clear%20sky%2C%20nostalgic%20tender%20film%20still%2C%20film%20grain%2C%20no%20text%2C%20high%20detail%2C%20dramatic%20cinematography&width=1920&height=900&seq=hero-03&orientation=landscape",
    tag: "治愈精选",
    title: "春日来信",
    slogan: "一叠没有寄出的信，拼出一个被掩埋的春天",
    description: "女孩在祖母旧屋发现从未寄出的信件，带着它们踏上寻找过去的旅程。全10集温暖上线。",
  },
];

export type Collection = {
  id: string;
  title: string;
  subtitle: string;
  genre: string;
  cover: string;
};

export const collections: Collection[] = [
  {
    id: "neighbor-wife",
    title: "“邻居的妻子”同款专题",
    subtitle: "都市情感 · 人性群像精选合集",
    genre: "都市",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20moody%20apartment%20window%20at%20night%20with%20warm%20lamp%20glow%20and%20deep%20navy%20shadows%2C%20emotional%20urban%20drama%20film%20still%2C%20atmospheric%20lighting%2C%20film%20grain%2C%20no%20text%2C%20high%20detail&width=800&height=600&seq=col-01&orientation=landscape",
  },
  {
    id: "suspense-night",
    title: "深夜悬疑剧场",
    subtitle: "刑侦 · 推理 · 烧脑合集",
    genre: "悬疑",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20dim%20interrogation%20room%20with%20a%20single%20hanging%20lamp%2C%20long%20shadows%20and%20cold%20navy%20tones%20with%20warm%20highlight%2C%20tense%20mystery%20film%20still%2C%20film%20grain%2C%20no%20text%2C%20high%20detail&width=800&height=600&seq=col-02&orientation=landscape",
  },
  {
    id: "healing-heart",
    title: "治愈暖光合集",
    subtitle: "爱情 · 家庭 · 成长治愈",
    genre: "爱情",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20cozy%20warm%20cafe%20interior%20by%20a%20window%20with%20soft%20afternoon%20sunlight%20and%20steaming%20coffee%2C%20warm%20amber%20and%20cream%20tones%2C%20gentle%20healing%20film%20still%2C%20film%20grain%2C%20no%20text%2C%20high%20detail&width=800&height=600&seq=col-03&orientation=landscape",
  },
  {
    id: "period-time",
    title: "岁月年代剧场",
    subtitle: "年代 · 家庭 · 群像记忆",
    genre: "年代",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20nostalgic%20old%20town%20street%20with%20warm%20evening%20sunlight%20and%20vintage%20signage%2C%20warm%20amber%20and%20earth%20brown%20tones%2C%20sentimental%20period%20film%20still%2C%20film%20grain%2C%20no%20text%2C%20high%20detail&width=800&height=600&seq=col-04&orientation=landscape",
  },
];